const DISALLOWED_TAGS = new Set(['script', 'style', 'object', 'embed', 'form', 'input', 'button']);

function isSafeIframeSrc(value: string): boolean {
  const trimmed = value.trim().toLowerCase();
  return (
    trimmed.startsWith('https://www.youtube.com/embed/') ||
    trimmed.startsWith('https://youtube.com/embed/') ||
    trimmed.startsWith('https://www.youtube-nocookie.com/embed/')
  );
}

function isSafeHref(value: string): boolean {
  const trimmed = value.trim().toLowerCase();
  return (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('#') ||
    trimmed.startsWith('/')
  );
}

export function sanitizeLinerNotesHtml(input: string): string {
  if (!input || typeof input !== 'string') return '';
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');

  const nodes = Array.from(doc.body.querySelectorAll('*'));
  for (const node of nodes) {
    const tag = node.tagName.toLowerCase();

    if (DISALLOWED_TAGS.has(tag)) {
      node.remove();
      continue;
    }

    const attrs = Array.from(node.attributes);
    for (const attr of attrs) {
      const name = attr.name.toLowerCase();
      const value = attr.value;

      if (name.startsWith('on')) {
        node.removeAttribute(attr.name);
        continue;
      }

      if ((name === 'href' || name === 'src') && !isSafeHref(value)) {
        node.removeAttribute(attr.name);
        continue;
      }

      if (tag === 'iframe' && name === 'src' && !isSafeIframeSrc(value)) {
        node.remove();
        continue;
      }

      if (tag === 'iframe') {
        const allowedIframeAttrs = new Set(['src', 'title', 'width', 'height', 'allow', 'allowfullscreen', 'loading', 'referrerpolicy']);
        if (!allowedIframeAttrs.has(name)) {
          node.removeAttribute(attr.name);
          continue;
        }
      }

      if (name === 'style') {
        node.removeAttribute(attr.name);
      }
    }

    if (tag === 'a') {
      node.setAttribute('rel', 'noopener noreferrer');
      if (!node.getAttribute('target')) {
        node.setAttribute('target', '_blank');
      }
    }

    if (tag === 'iframe') {
      node.setAttribute('loading', node.getAttribute('loading') || 'lazy');
      node.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      if (!node.hasAttribute('allowfullscreen')) {
        node.setAttribute('allowfullscreen', 'true');
      }
    }
  }

  return doc.body.innerHTML;
}
